<div class="buttons" [class.buttons--expanded]="isExpanded">
  <div class="bc-footer-buttons-left">
    <button
      [disabled]="isInteractionDisabled"
      (click)="onSend()"
      class="btn btn-light bc-footer-button"
      data-automation-id="gc-email-footer-reply-mode-send-button"
    >
      <span>{{ 'genesysEmailActionButtons.send' | translate }}</span>
    </button>

    <button
      [disabled]="isInteractionDisabled"
      (click)="openOutgoingHeaderPanel()"
      class="btn btn-light bc-footer-button"
      data-automation-id="gc-email-footer-reply-mode-subjects-and-recipients-button"
    >
      <span>{{ 'genesysEmailActionButtons.openOutgoingHeaderButton' | translate }}</span>
    </button>

    <app-genesys-email-attachment-button
      class="bc-footer-button"
      [disabled]="isInteractionDisabled"
      [conversationId]="conversationId"
      (sizeLimitError)="onAttachmentSizeLimitError($event)"
    ></app-genesys-email-attachment-button>
  </div>

  <div class="bc-footer-buttons-right clearfix">
    <button
      (click)="onReplyCancel()"
      class="btn btn-light bc-footer-button"
      data-automation-id="gc-email-footer-reply-mode-cancel-button"
    >
      <span>{{ 'genesysEmailActionButtons.cancelButton' | translate }}</span>
    </button>
    <button
      (click)="onHandleConfirmation()"
      class="btn btn-light bc-footer-button"
      data-automation-id="gc-email-footer-reply-mode-close-now-button"
    >
      <span>{{ 'genesysEmailActionButtons.closeNow' | translate }}</span>
    </button>
    <button
      (click)="onOpenWrapUpPanel()"
      class="btn btn-light bc-footer-button"
      data-automation-id="gc-email-footer-reply-mode-wrapup-button"
    >
      <span>{{ 'genesysEmailActionButtons.wrapUp' | translate }}</span>
    </button>
  </div>
</div>
